/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PausePrescriptionDialog.vue?vue&type=template&id=a92f9bf2"
import script from "./PausePrescriptionDialog.vue?vue&type=script&lang=js"
export * from "./PausePrescriptionDialog.vue?vue&type=script&lang=js"
import style0 from "./PausePrescriptionDialog.vue?vue&type=style&index=0&id=a92f9bf2&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a92f9bf2')) {
      api.createRecord('a92f9bf2', component.options)
    } else {
      api.reload('a92f9bf2', component.options)
    }
    module.hot.accept("./PausePrescriptionDialog.vue?vue&type=template&id=a92f9bf2", function () {
      api.rerender('a92f9bf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/patients/PausePrescriptionDialog.vue"
export default component.exports